import React from "react";
import { useSelector } from "react-redux";
import { MenuData } from "./MenuData";
import MenuLinkItem from "./MenuLinkItem";
import { filterMenuData } from "../utilities/filterMenuData";

const MenuLinks = ({ menuItems, toggleSidebar }) => {
  const rolePermissions = useSelector((state) => {
    console.log("Role Permissions:", state.auth.loggedInUserRolePermissions);
    return state.auth.loggedInUserRolePermissions;
  });

  // Filter menu items based on permissions
  const filteredMenuData = filterMenuData(menuItems, rolePermissions);

  if (
    filteredMenuData.filter(
      (item) => item.permissionCategoryName === "Dashboard",
    ).length > 1
  ) {
    // console.warn("Duplicate Dashboard items detected in filteredMenuData");
  }

  // Find Feedback and Support menu items
  const feedbackMenuItem = MenuData.find(
    (item) => item.permissionCategoryName === "Feedback",
  );
  const supportMenuItem = MenuData.find(
    (item) => item.permissionCategoryName === "Help & Support Center",
  );

  return (
    <>
      {filteredMenuData.map((item) => (
        <MenuLinkItem
          key={item.id}
          id={item.id}
          icon={item.icon}
          label={item.permissionCategoryName}
          to={item.path}
          subMenu={item.subMenu}
          toggleSidebar={toggleSidebar}
        />
      ))}

      {/* Always render the Feedback and Support menu items if they exist, without any permission requirements */}
      {feedbackMenuItem && (
        <MenuLinkItem
          key={feedbackMenuItem.id}
          id={feedbackMenuItem.id}
          icon={feedbackMenuItem.icon}
          label={feedbackMenuItem.permissionCategoryName}
          to={feedbackMenuItem.path}
          subMenu={feedbackMenuItem.subMenu}
          toggleSidebar={toggleSidebar}
        />
      )}

      {supportMenuItem && (
        <MenuLinkItem
          key={supportMenuItem.id}
          id={supportMenuItem.id}
          icon={supportMenuItem.icon}
          label={supportMenuItem.permissionCategoryName}
          to={supportMenuItem.path}
          subMenu={supportMenuItem.subMenu}
          toggleSidebar={toggleSidebar}
        />
      )}
    </>
  );
};

export default MenuLinks;
